// based on vc-dialog 8.6.0
import DialogWrap from './DialogWrap';
import dialogProps from './IDialogPropTypes';
export { dialogProps };
export default DialogWrap;
